import { render } from "./FormPermission.vue?vue&type=template&id=70b6c3b4&scoped=true"
import script from "./FormPermission.vue?vue&type=script&lang=js"
export * from "./FormPermission.vue?vue&type=script&lang=js"

import "./FormPermission.vue?vue&type=style&index=0&id=70b6c3b4&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b6c3b4"]])

export default __exports__